var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#F8B400",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.939 39.1262V54.8769H36.4558L51.9824 63.0618L67.5091 54.8769H69.0259V39.1262C69.0259 37.7571 68.1049 36.6444 66.9655 36.6444H36.9994C35.8627 36.6444 34.939 37.7537 34.939 39.1262Z",
    fill: "#F8B400",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06787 80.1052V81.8504",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2727 82.5868H8.81836",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42074 82.5868H5.96509",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06787 83.434V85.1792",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9292 22.1568V23.902",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1335 24.6384H32.6792",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2818 24.6384H29.8262",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9292 25.4856V27.2308",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5811 34.9388V36.684",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7854 37.4204H92.3311",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9337 37.4204H89.478",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5811 38.266V40.0112",
    stroke: "#005555",
    strokeWidth: 0.793333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.633 44.527H17.5579C16.7303 44.527 16.3884 43.4661 17.0604 42.9829L51.9496 17.8957L86.9005 42.9825C87.5731 43.4653 87.2316 44.527 86.4035 44.527H73.9804",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8555 44.5277V90.3009C86.8555 91.2422 86.0925 92.0052 85.1512 92.0052H18.7478C17.8065 92.0052 17.0435 91.2422 17.0435 90.3009V44.5277",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3218 91.1826L51.9496 68.5667L85.0044 91.1826H18.3218Z",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0435 44.5277L45.9118 63.3864",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9221 44.5277L58.0537 63.3864",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7734 51.8065V37.5903C33.7734 36.3515 34.7777 35.3503 36.0135 35.3503H68.5923C69.8311 35.3503 70.8323 36.3545 70.8323 37.5903V51.8065",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7721 68.3677C54.4656 68.3677 56.6491 66.1841 56.6491 63.4906C56.6491 60.7971 54.4656 58.6136 51.7721 58.6136C49.0785 58.6136 46.895 60.7971 46.895 63.4906C46.895 66.1841 49.0785 68.3677 51.7721 68.3677Z",
    fill: "white",
    stroke: "#005555",
    strokeWidth: 0.656174,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5771 63.4184C54.5771 64.4437 54.1952 65.0481 53.5758 65.0481C53.1819 65.0481 52.9173 64.8075 52.8933 64.3896C52.6527 64.8075 52.2167 65.0481 51.6845 65.0481C50.8276 65.0481 50.1871 64.3956 50.1871 63.4845C50.1871 62.5795 50.8276 61.933 51.6845 61.933C52.2047 61.933 52.6317 62.1615 52.8812 62.5675V61.9571H53.2751V64.2453C53.2751 64.582 53.4435 64.7053 53.648 64.7053C54.0238 64.7053 54.2644 64.2392 54.2644 63.4244C54.2644 62.0052 53.2451 61.064 51.7838 61.064C50.3044 61.064 49.2971 62.0533 49.2971 63.4845C49.2971 64.9158 50.2924 65.917 51.7597 65.917C52.1235 65.917 52.5685 65.8328 52.9203 65.6524L53.0226 65.9471C52.6587 66.1335 52.1656 66.2237 51.7597 66.2237C50.1 66.2237 48.9634 65.0811 48.9634 63.4815C48.9634 61.8759 50.115 60.7513 51.7838 60.7513C53.4195 60.7543 54.5771 61.8368 54.5771 63.4184ZM52.8873 63.4845C52.8873 62.7539 52.3911 62.2818 51.7387 62.2818C51.0681 62.2818 50.584 62.7599 50.584 63.4845C50.584 64.2092 51.0681 64.6993 51.7387 64.6993C52.3911 64.6993 52.8873 64.2212 52.8873 63.4845Z",
    fill: "#005555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8052 41.0059H65.6186",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0024 43.5774H61.4239",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2865 51.8057H49.2526C47.7733 51.8057 46.5615 50.5939 46.5615 49.1146C46.5615 47.6352 47.7733 46.4235 49.2526 46.4235H52.2865",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4893 46.4268H56.5231C58.0025 46.4268 59.2142 47.6386 59.2142 49.1179C59.2142 50.5973 58.0025 51.809 56.5231 51.809H53.4893",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4238 49.1148H55.5908",
    stroke: "#005555",
    strokeWidth: 0.826609,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEmail);
export default __webpack_public_path__ + "static/media/editEmail.b43a6c54b1e66dd42e8409e4032d791c.svg";
export { ForwardRef as ReactComponent };